import React from "react";
import SideModal from "components/SideModal";
import { useFormattedMessage } from "hooks";
import SharesValuationBlock from "components/SharesValuationBlock";
import CustomFormatNumber from "components/CustomFormatNumber";
import { ProductProvisionInformation } from "components/Admin/Projects/ProductDetailModal";
import ExpandableTwoRowDown from "components/SidemodalComponents/ExpandableTwoRowDown";
import DownloadButton from "components/DownloadButton";

const messages = {
    fundingPercentage: "funding_percentage",
    totalNumberOfShares: "total_number_of_shares",
    financialAmount: "financial_amount",
};

const ProductDetailModal = ({ onCloseButtonClick, open, data }) => {
    const { formatMessage } = useFormattedMessage();

    return (
        <SideModal
            className="editable-modal"
            open={open}
            onCloseButtonClick={onCloseButtonClick}
            heading={
                <>
                    {data?.projectID}{" "}
                    <span class="text-14 primary-color fw-500">{`(${data?.status?.status?.toUpperCase()})`}</span>
                </>
            }
            containerClassName={"mw-100 pt-0"}
            wrapClassName="px-0"
        >
            {data?.images?.teaserImage?.path ? (
                <img className="sidepage-banner-image pb-5" src={`${data?.images?.teaserImage?.path}?h=300`} alt="" />
            ) : (
                <div className="placeholder-img d-flex align-center justify-center mb-5">
                    <p className="mb-0">No available project in Takeshape</p>
                </div>
            )}
            <div className="content-part px-5">
                <div className="d-flex">
                    {(data?.CategoryProduct || data?.TypeProduct) && (
                        <span className="text-12 tag d-inline-block">
                            {data?.CategoryProduct ? `${data?.CategoryProduct} - ${data?.TypeProduct}` : data?.TypeProduct}
                        </span>
                    )}
                </div>
                <h3 className="mb-4">{data?.title}</h3>
                <SharesValuationBlock
                    className="black full-size my-10 min-height-auto"
                    lClassname="text-18"
                    title={formatMessage(messages.fundingPercentage)}
                    finalValuation={<CustomFormatNumber className="text-18" noSymbol value={data?.fundingPercentage} />}
                    finalValuationSymbol="%"
                    finalValuationSymbolClassName="text-18"
                    valuations={[
                        {
                            title: formatMessage(messages.totalNumberOfShares),
                            value: data?.financials?.numberOfShares,
                            symbol: "",
                            lClassname: "text-16",
                        },
                        {
                            title: formatMessage(messages.financialAmount),
                            value: data?.financials?.numberOfShares,
                            lClassname: "text-16",
                        },
                    ]}
                />

                <ProductProvisionInformation
                    title="Provision"
                    data={{
                        Provision: data?.provision || 0,
                    }}
                />
                <ExpandableTwoRowDown title="Documents" rowContainerClassname="mb-6">
                    {data?.details?.documents?.map((item, index) => {
                        return <DownloadButton key={index} isToken fileURL={item?.list?.path} title={item?.list?.title} />;
                    })}
                </ExpandableTwoRowDown>
            </div>
        </SideModal>
    );
};

export default ProductDetailModal;
